export const ANNOUNCEMENTS = {
  FIX: { color: 'red', text: '錯誤修正' },
  ANNOUNCEMENT: { color: 'blue', text: '通知' },
  NEW: { color: 'yellow', text: '新功能' },
  IMPROVEMENT: { color: 'green', text: '改進' },
  OTHER: { color: 'grey', text: '其他' },
}
